export const ROLES = {
  hokkaidoAdmin: 'HokkaidoAdmin',
  administrator: 'Administrator',
  employee: 'Employee',
  approver: 'Approver',
};
